module.exports = __webpack_public_path__ + "media/images/pc/stores/nagoya/access/nagoya_point2_4-6e5ca530dc9059d9d99fb46fe3101415.jpg";